// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 479) return "static/chunks/479-1223d07a2fa32d98.js";
	if (chunkId === 134) return "static/chunks/134-b4e8fae52346cd18.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"519":"5faa35797a213fcc","969":"c592b9e42e25d1d3"}[chunkId] + ".js";
};